import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteResourceTemplateMutation } from "../../services/appln";

export default function DeleteResourceTemplate(props: any): any {
  return (
    <DeletePanel
      deleteMutation={useDeleteResourceTemplateMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteResourceTemplateTitle}
      confirmationDialogMsg={strings.deleteResourceTemplateConfirmation}
      errorDialogTitle={strings.deleteResourceTemplateFailedTitle}
      errorDialogMsg={strings.deleteResourceTemplateFailedMsg}
    />
  );
}
